import { render, staticRenderFns } from "./TestimonialsPage.vue?vue&type=template&id=a7094ee0&scoped=true"
import script from "./TestimonialsPage.vue?vue&type=script&lang=js"
export * from "./TestimonialsPage.vue?vue&type=script&lang=js"
import style0 from "./TestimonialsPage.vue?vue&type=style&index=0&id=a7094ee0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7094ee0",
  null
  
)

export default component.exports